import { Form, FormField, FormSubmit, useForm } from "@thekrystalship/krystal";
import { discoverProvider, originOf } from "../../lib/oidc.js";
import { AuthShell } from "./AuthChrome.jsx";

// ClusterPage — one address, and nothing else.
//
// Shown only to a panel whose own origin names no sign-in provider and which has no entry node: one
// served from a static host, a laptop, a bucket. Any node of the cluster answers where its provider
// is. What was typed is checked before it is kept, so a refusal is what something answered rather than
// a guess about what was typed.

const REFUSAL = {
  invalid: "That is not a usable address.",
  unreachable: "Nothing there answered as a node of a cluster.",
  no_provider: "That node doesn’t know its cluster’s sign-in yet. Try again shortly.",
};

function ClusterPage({ onFound }) {
  const form = useForm({
    defaultValues: { address: "" },
    mode: "change",
    validate: { address: (v) => (!v.trim() || originOf(v.trim()) ? undefined : REFUSAL.invalid) },
    onSubmit: async ({ address }) => {
      const found = await discoverProvider(address.trim());
      if (!found.ok) return { message: REFUSAL[found.reason] || REFUSAL.unreachable };
      onFound(found);
      return undefined;
    },
  });

  const typed = form.values.address.trim();
  const usable = !!originOf(typed);

  return (
    <AuthShell tagline="Sign in to your control panel.">
      <div className="auth-card__heading">Where is your cluster?</div>

      <Form form={form} className="auth-card__form">
        <FormField
          name="address"
          control="input"
          id="cluster-address"
          aria-label="Address"
          size="lg" mono
          prefix="https://"
          placeholder="kgsm.example.com"
          spellCheck="false" autoCapitalize="off" autoCorrect="off" autoFocus />

        <FormSubmit size="xl" wide busyLabel="Checking…" iconRight={form.isSubmitting ? null : "arrow-right"} disabled={!usable}>
          Next
        </FormSubmit>
      </Form>
    </AuthShell>
  );
}

export { ClusterPage };
